'use strict';

import { FullScreenQuad, Pass } from 'three/examples/jsm/postprocessing/Pass';
import { Color, ShaderMaterial, UniformsUtils } from 'three';
import { Effect } from './Effect';
import { HighlightsCompressionShader } from './Shaders/HighlightsCompression/HighlightsCompressionShader';

class HighlightsCompression extends Pass{
	constructor () {
		super();
		
		this.highlightMaterial = new ShaderMaterial({
			uniforms: UniformsUtils.clone(HighlightsCompressionShader.uniforms),
			vertexShader: HighlightsCompressionShader.vertexShader,
			fragmentShader: HighlightsCompressionShader.fragmentShader,
			transparent: true,
			depthWrite: false,
			depthTest: false
		});
		
		this.fsQuad = new FullScreenQuad(null);
		this.originalClearColor = new Color();
		this.needsSwap = false;
	}
	
	render (renderer, writeBuffer, readBuffer) {
		this.highlightMaterial.uniforms.tDiffuse.value = readBuffer.texture;
		this.renderPass(renderer,this.highlightMaterial,this.renderToScreen ? null : readBuffer);
	}
	
	renderPass( renderer, passMaterial, renderTarget, clearColor, clearAlpha ) {
		// save original state
		renderer.getClearColor( this.originalClearColor );
		const originalClearAlpha = renderer.getClearAlpha();
		const originalAutoClear = renderer.autoClear;
		
		renderer.setRenderTarget( renderTarget );
		
		// setup pass state
		renderer.autoClear = false;
		if ( ( clearColor !== undefined ) && ( clearColor !== null ) ) {
			
			renderer.setClearColor( clearColor );
			renderer.setClearAlpha( clearAlpha || 0.0 );
			renderer.clear();
			
		}
		
		this.fsQuad.material = passMaterial;
		this.fsQuad.render( renderer );
		
		// restore original state
		renderer.autoClear = originalAutoClear;
		renderer.setClearColor( this.originalClearColor );
		renderer.setClearAlpha( originalClearAlpha );
	}
	
}


export class HighlightsCompressionEffect extends Effect{
	constructor () {
		super();
	
		this.effect = new HighlightsCompression();
		this.active = false;
	}
	
	get config() {
		return {
			active: this.active,
			highlightThreshold: this.effect.highlightMaterial.uniforms.highlightThreshold.value,
			highlightCompression: this.effect.highlightMaterial.uniforms.highlightCompression.value
		};
	}
	
	set config(config) {
		Object.entries(config).forEach(([key,value]) => {
			if (key === 'active') {
				this.active = value;
			} else {
				this.effect.highlightMaterial.uniforms[key].value = value;
			}
		});
	}
}
